<script>

export default {
  name: 'regularJson',
  data (){
    return {
      regular : [
        {
          title :  '',
          Introduction:
            `var patt1 = new RegExp(/^[A-Z]+$/);
patt1.test("WWWW")
true`
        },
        {
          title :  `手机号`,
          Introduction: `/^1((3[\d])|(4[5,6,9])|(5[0-3,5-9])|(6[5-7])|(7[0-8])|(8[1-3,5-8])|(9[1,8,9]))\d{8}$/`,    
        },
        {
          title :  `大写字母`,
          Introduction: `/^[A-Z]+$/`,    
        },
        {
          title :  `email地址`,
          Introduction: `/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/`,    
        },
        {
          title :  `国内座机电话,如: 0341-86091234`,
          Introduction: `/\d{3}-\d{8}|\d{4}-\d{7}/`,    
        },
        {
          title :  `身份证号(15位、18位数字)，最后一位是校验位，可能为数字或字符X`,
          Introduction: `/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/`,    
        },
        {
          title :  `帐号是否合法(字母开头，允许5-16字节，允许字母数字下划线组合`,
          Introduction: `/^[a-zA-Z][a-zA-Z0-9_]{4,15}$/`,    
        },
        {
          title :  `只包含中文`,
          Introduction: `/^[\u4E00-\u9FA5]/`,    
        },
        {
          title :  `是否小数`,
          Introduction: `/^\d+\.\d+$/`,    
        },
        {
          title :  `是否电话格式(手机和座机)`,
          Introduction: `/^((0\d{2,3}-\d{7,8})|(1[345789]\d{9}))$/`,    
        },
        {
          title :  `是否8位纯数字`,
          Introduction: `/^[0-9]{8}$/`,    
        },
        {
          title :  `是否qq号格式正确`,
          Introduction: `/^[1-9]*[1-9][0-9]*$/`,    
        },
        {
          title :  `是否由数字和字母组成`,
          Introduction: `/^[A-Za-z0-9]+$/`,    
        },
        {
          title :  `是否小写字母组成`,
          Introduction: `/^[a-z]+$/`,    
        },
        {
          title :  `密码强度正则，最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符`,
          Introduction: `/^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/`,    
        },
        {
          title :  `用户名正则，4到16位（字母，数字，下划线，减号）`,
          Introduction: `/^[a-zA-Z0-9_-]{4,16}$/`,    
        },
        {
          title :  `ipv4地址正则`,
          Introduction: `/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/`,    
        },
        {
          title :  `16进制颜色`,
          Introduction: `/^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/`,    
        },
        {
          title :  `微信号，6至20位，以字母开头，字母，数字，减号，下划线`,
          Introduction: `/^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/`,    
        },
        {
          title :  `中国邮政编码`,
          Introduction: `/^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/`,    
        },
        {
          title :  `只包含中文和数字`,
          Introduction: `/^(([\u4E00-\u9FA5])|(\d))+$/`,    
        },
        {
          title :  `非字母`,
          Introduction: `/[^A-Za-z]/`,    
        },
        {
          title :  `车牌号正则`,
          Introduction: `var cPattern = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/;
//输出 true
console.log(cPattern.test("京K39006"));`,    
        },
      ]
    }
  }
}
</script>